import { render, staticRenderFns } from "./shipmentsdispatched.vue?vue&type=template&id=f36f9cce&scoped=true"
import script from "./shipmentsdispatched.vue?vue&type=script&lang=js"
export * from "./shipmentsdispatched.vue?vue&type=script&lang=js"
import style0 from "./shipmentsdispatched.vue?vue&type=style&index=0&id=f36f9cce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36f9cce",
  null
  
)

export default component.exports